var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4Archives(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10v56h48V10H14zm22 52H18V14h18v48zm22 0H40V14h18v48zm-4-31H44v-4h10v4zm0-8H44v-4h10v4zm-2 31.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM32 31H22v-4h10v4zm0-8H22v-4h10v4zm-2 31.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Archives.ba64bf35.svg";
export { SvgE4Archives as ReactComponent };